import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({tag}) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return    <div
  dangerouslySetInnerHTML={{
    __html: tag?.body_tag
  }}
/>;
};

export default ScrollToTop;
